import PermissionsInstance from 'modules/permissions/repository';

export const fetchPermissionGroups = (scopeType, scopeId, opts) => {
  return PermissionsInstance.getPermissionGroups(scopeType, scopeId, opts);
};

export const fetchMembersPermissions = (scopeType, scopeId, opts) => {
  return PermissionsInstance.getScopeMembersPermissions(scopeType, scopeId, opts);
};
